/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';

/**
 * 
 * @export
 * @interface CreateDeckExerciseDTO
 */
export interface CreateDeckExerciseDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateDeckExerciseDTO
     */
    deckId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeckExerciseDTO
     */
    exerciseId: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof CreateDeckExerciseDTO
     */
    exerciseConfig?: ExerciseConfig;
}

/**
 * Check if a given object implements the CreateDeckExerciseDTO interface.
 */
export function instanceOfCreateDeckExerciseDTO(value: object): value is CreateDeckExerciseDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    return true;
}

export function CreateDeckExerciseDTOFromJSON(json: any): CreateDeckExerciseDTO {
    return CreateDeckExerciseDTOFromJSONTyped(json, false);
}

export function CreateDeckExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeckExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'exerciseId': json['exerciseId'],
        'exerciseConfig': json['exerciseConfig'] == null ? undefined : ExerciseConfigFromJSON(json['exerciseConfig']),
    };
}

export function CreateDeckExerciseDTOToJSON(json: any): CreateDeckExerciseDTO {
    return CreateDeckExerciseDTOToJSONTyped(json, false);
}

export function CreateDeckExerciseDTOToJSONTyped(value?: CreateDeckExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'exerciseId': value['exerciseId'],
        'exerciseConfig': ExerciseConfigToJSON(value['exerciseConfig']),
    };
}

